import { api } from "..";
import { CreateWebhook, PaginatedResponse, ResponseDto, ResponseListDto, UpdateWebhook, Webhook, WebhookEvent, WebhookSearch  } from "../../types/domain";

export const getWebhooks = async (): Promise<WebhookSearch[]> => {
  const response = await api.get<PaginatedResponse<WebhookSearch>>(`/webhook`);
  if (response.status !== 200) {
    throw new Error(`Failed to load webhooks.`);
  }

  // just take the data, ignore the meta / message for now
  const responseDto = response.data?.data as WebhookSearch[] ?? [];
  
  // TODO: map to domain model, should be using to use the ResponseListDto to preserve the {data, meta} structure
  return responseDto;
};

export const getWebhook = async (id: string): Promise<Webhook | null> => {
  const response = await api.get<ResponseDto<Webhook>>(`/webhook/${id}`);
  if (response.status !== 200) {
    throw new Error(`Failed to load webhook.`);
  }
  return response.data?.data as Webhook ?? null;
};

export const getWebhookEvents = async (): Promise<WebhookEvent[]> => {
  const response = await api.get<ResponseListDto<WebhookEvent>>(`/webhook/event`);
  if (response.status !== 200) {
    throw new Error(`Failed to load webhook events.`);
  }

  // just take the data, ignore the meta / message for now
  const responseDto = response.data?.data as WebhookEvent[] ?? [];
  return responseDto;
};

export const deleteWebhook = async (id: number | undefined): Promise<void> => {
  if (id === undefined || id <= 0 || id > Number.MAX_SAFE_INTEGER) {
    throw new Error('Webhook Id is required');
  }

  const response = await api.delete<void>(`/webhook/${id}`);
  if (response.status !== 204) {
    throw new Error('Failed to delete webhook.');
  }
};

export const createWebhook = async (webhook: CreateWebhook): Promise<number> => {
  const response = await api.post<ResponseDto<number>>(`/webhook`, webhook);
  if (response.status !== 201) {
    throw new Error(`Failed to create webhook.`);
  }
  return response.data?.data as number;
};

export const updateWebhook = async (webhook: UpdateWebhook): Promise<boolean | null> => {
  if (webhook.id === undefined || webhook.id <= 0 || webhook.id > Number.MAX_SAFE_INTEGER) {
    throw new Error('Webhook Id is required');
  }
  const response = await api.put<Webhook>(`/webhook/${webhook.id}`, webhook);
  if (response.status !== 200) {
    throw new Error(`Failed to update webhook.`);
  }
  return true;
};

export const regenerateWebhookSecret = async (id: number | undefined): Promise<void> => {
  if (id === undefined || id <= 0) {
    throw new Error('Webhook Id is required');
  }

  const response = await api.post<string>(`/webhook/${id}/regenerateWebhookSecret`);
  if (response.status !== 200) {
    throw new Error('Failed to regenerate webhook secret.');
  }
};